import { render, staticRenderFns } from "./ColaboradorDetail.vue?vue&type=template&id=7892a1fe&scoped=true"
import script from "./ColaboradorDetail.vue?vue&type=script&lang=js"
export * from "./ColaboradorDetail.vue?vue&type=script&lang=js"
import style0 from "./ColaboradorDetail.vue?vue&type=style&index=0&id=7892a1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_310753db291b809859cbd9e654a8ef6f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7892a1fe",
  null
  
)

export default component.exports